import { Injectable } from '@angular/core';
import { CollectionReference, DocumentReference } from '@angular/fire/firestore/interfaces';

@Injectable({
  providedIn: 'root'
})
export class QuizService {
  private selectedTest:any;
  private ref:DocumentReference;
  private subjectRef:DocumentReference;
  constructor() {

   }
   selectTest(test){
    this.selectedTest = test;
    console.log(test);
   }
   getSelectedTest(){
     return this.selectedTest;
   }
   setRef(ref:DocumentReference){
    this.ref = ref;
   }
   setSubjectRef(ref:DocumentReference){
    this.subjectRef = ref;
   }
   getRef(){
     return this.ref;
   }
   getSubjectRef(){
     return this.subjectRef;
   }

}
